import { logger } from '@tunasong/models'
import { OAuth } from '@tunasong/redux'
import { useState } from 'react'

/** Shown where the sign-in buttons are when sign-in can't start (copy approved by Brian, 2026-10-25) */
export const signInStartFailedMessage = "Sign-in couldn't start. Try again, or use a different browser."

/**
 * Start sign-in (or sign-up) from a button, and know when it couldn't start, so the button can say so (GH #2840
 * follow-up). `authorize()` redirects away on success; it rejects when it can't even build the request, e.g. when the
 * browser has no secure context for the PKCE digest. Before, the click was fire-and-forget and nothing happened.
 */
export const useStartSignIn = () => {
  const [failed, setFailed] = useState(false)

  const start = (options?: { signup?: boolean }) => {
    setFailed(false)
    /** Called in the click, as before; only its outcome is awaited */
    void Promise.resolve(OAuth.authorize(options)).catch((error: unknown) => {
      logger.error('Sign-in could not start', error)
      setFailed(true)
    })
  }

  return { start, failed }
}
